import type { ProductWith } from '@scayle/storefront-nuxt'
import { sustainabilityAttributes } from '../../../layers/base/utils/sustainability'

export const SEARCH_PRODUCT_WITH_PARAMS: ProductWith = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'brand',
      'name',
      'color',
      'premiumsegment',
    ],
  },
  variants: {
    lowestPriorPrice: true,
    attributes: {
      withKey: ['price', 'size', 'sizeCategory'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  categories: {
    properties: {
      withName: ['categoryName'],
    },
  },
  siblings: {
    images: {
      attributes: {
        withKey: ['imageType', 'imageView', 'imageBackground'],
      },
    },
    attributes: {
      withKey: ['colorRange', 'colorHex', 'name', 'brand', 'color'],
    },
  },
  priceRange: true,
  lowestPriorPrice: true,
}

export const PRODUCTS_PER_PAGE = 60
export const MINIMUM_QUANTITY_IMMEDIATE_AVAILABILITY = 5
export const PRODUCT_WITH_PARAMS: ProductWith = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'color',
      'brand',
      'name',
      'size_note',
      ...sustainabilityAttributes,
      'premiumsegment',
    ],
  },
  variants: {
    lowestPriorPrice: true,
    attributes: {
      withKey: ['price', 'sizeCategory'],
    },
  },
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color', 'brand', 'name'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  priceRange: true,
  categories: {
    properties: {
      withName: ['baseCategories'],
    },
  },
  lowestPriorPrice: true,
}

/**
 * Product with only the details of the product
 * Does not include siblings
 */
export const PRODUCT_ONLY_DETAILS_WITH: ProductWith = {
  attributes: {
    withKey: [
      'articleType',
      'color',
      'colorHex',
      'colorRange',
      'brand',
      'name',
      'brandLogo',
      'shoeMaterialStyle',
      'fastenerType',
      'materialStyle',
      'necklineStyle',
      'design',
      'extras',
      'material',
      'fitting',
      'upperLength',
      'sleeveLength',
      'shirtCut',
      'bottomLength',
      'trousersCut',
      'careSymbol',
      'elasticity',
      'knitMaterialType',
      'sportType',
      'washComment',
      'isQuantityChangeDisabled',
      'recommendations',
      'caresymbolWash',
      'caresymbolBleaching',
      'caresymbolDry',
      'caresymbolIron',
      'caresymbolClean',
      'articleFeatureIcon',
      'directOrder',
      'mainOrderNumberList',
      'sizeNote',
      'isExcludedFromSearch',
    ],
  },
  advancedAttributes: {
    withKey: [
      'articlePlacement',
      'materialCompositionTextile',
      'longdescription',
      'standardtext',
      'webtext',
      'sellingPoint1Dessin',
      'sellingPoint2Material',
      'sellingPoint3AGSSpezialDetail',
      'sellingPoint4InternEinkauf',
      'material',
      'mainOrderNumber',
      'ordernumber',
      'creditorName',
      'creditorAdress',
      'creditorPostCode',
      'creditorCity',
      'creditorCountry',
      'creditorWeb',
    ],
  },
  variants: {
    attributes: {
      withKey: [
        'sizeCategory',
        'sizeCategorySize',
        'price',
        'size',
        'erpSizeKey',
        'restockDate',
        'productOrderNumber',
        'productOrderNumberList',
      ],
    },
    lowestPriorPrice: true,
    advancedAttributes: {
      withKey: ['measures'],
    },
  },
  images: {
    attributes: {
      withKey: ['imageType', 'imageView', 'imageBackground', 'assetType'],
    },
  },
  categories: {
    properties: 'all' as const,
    countryLevelCustomData: true,
    shopLevelCustomData: true,
  },
  priceRange: true,
  lowestPriorPrice: true,
}

/**
 * Product with details of the product
 * Includes basic sibling details
 */
export const PRODUCT_DETAILS_SIBLINGS_WITH: ProductWith = {
  images: {
    attributes: {
      withKey: [
        'imageType',
        'imageView',
        'imageBackground',
        'frameColor',
        'assetType',
      ],
    },
  },
  attributes: {
    withKey: [
      'color',
      'colorHex',
      'colorRange',
      'name',
      'brand',
      'premiumsegment',
      'directOrder',
    ],
  },
  advancedAttributes: {
    withKey: ['ordernumber', 'articlePlacement'],
  },
}

export const PRODUCT_DETAILS_WITH: ProductWith = {
  ...PRODUCT_ONLY_DETAILS_WITH,
  siblings: PRODUCT_DETAILS_SIBLINGS_WITH,
}

export const PDP_PRODUCT_DETAILS_WITH: ProductWith = {
  ...PRODUCT_DETAILS_WITH,
  siblings: {
    ...PRODUCT_DETAILS_SIBLINGS_WITH,
    // External HTF badges read category ancestry from the initial PDP siblings.
    categories: {},
  },
}

/**
 * Product with details of the product
 * Includes full sibling details
 */
export const PRODUCT_SIBLINGS_DETAILS_WITH: ProductWith = {
  ...PRODUCT_ONLY_DETAILS_WITH,
  siblings: PRODUCT_ONLY_DETAILS_WITH,
}
